<template>
    <div class="layout-container">
        <el-tabs type="border-card">
            <el-tab-pane label="代理商列表">
                <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con" :class="isShowMore && 'show'">
                        <div class="search-condition">
                            <span class="label">代理商</span>
                            <div class="input-condition">
                                <factor-auto-complete v-model="condition.id" clearable ></factor-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">联系人</span>
                            <div class="input-condition">
                                <el-autocomplete v-model="condition.contacts" :fetch-suggestions="querySearchAsync2" placeholder="请输入内容" valueKey="contacts"></el-autocomplete>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">联系人电话</span>
                            <div class="input-condition">
                                <el-autocomplete v-model="condition.contact_number" :fetch-suggestions="querySearchAsync3" placeholder="请输入内容" valueKey="contact_number"></el-autocomplete>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">签约状态</span>
                            <div class="input-condition">
                                <el-select v-model="condition.status">
                                    <el-option value="-1" label="全部"></el-option>
                                    <el-option value="0" label="未签约"></el-option>
                                    <el-option value="1" label="已签约"></el-option>
                                    <el-option value="2" label="已解约"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">费用状态</span>
                            <div class="input-condition">
                                <el-select v-model="condition.fee_status">
                                    <el-option value="-1" label="全部"></el-option>
                                    <el-option value="0" label="正常"></el-option>
                                    <el-option value="1" label="欠费"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <!-- <div class="search-condition">
                            <span class="label">推送状态</span>
                            <div class="input-condition">
                                <el-select v-model="condition.push_status">
                                    <el-option value="-1" label="全部"></el-option>
                                    <el-option value="0" label="未配置"></el-option>
                                    <el-option value="1" label="正常"></el-option>
                                    <el-option value="2" label="异常"></el-option>
                                </el-select>
                            </div>
                        </div> -->
                    </div>
                    <a class="el-icon-d-arrow-left search-arrow-down" :class="!isShowMore && 'hide'" @click.stop="isShowMore = !isShowMore"></a>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch()">查 询</el-button>
                        <el-button  @click="resetSearch()">清空条件</el-button>
                    </div>
                </div>
                <div>
                    <div class="clearfix" style="margin-bottom: 5px" >
                        <el-button-group class="floatR" >
                                <el-tooltip class="item" effect="dark" content="新增代理商" placement="top">
                                    <el-button  @click="handleAdd()" icon="el-icon-plus" v-permission="'business.factor.add'" ></el-button>
                                </el-tooltip>
                        </el-button-group>
                    </div>
                    <el-table
                            :data="list"
                            style="width: 100%"
                            :highlight-current-row="true"
                            stripe
                            tooltip-effect="dark"
                            ref="multipleTable"
                            v-loading="isLoading"
                            header-cell-class-name="table-back"
                            :cell-class-name="cellStatus"
                    >
                        <!--  -->
                        <!-- 表头：label对应展示的名称 prop对应返回数据列表中绑定的字段名 sortable:标识当前列是否允许排序 -->
                        <el-table-column  label="ID" prop="id" width="80px"></el-table-column>
                        <el-table-column  label="代理商名称" prop="name" width="200px"></el-table-column>
                        <el-table-column  label="费用状态" prop="fee_status_string" width="80px"></el-table-column>
                        <el-table-column  label="权限站点" prop="sites_string" width="150px">
                            <template slot-scope="scope">
                                <p :title="scope.row.sites_placeholder">{{scope.row.sites_string}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column  label="联系人" prop="contacts" width="120px"></el-table-column>
                        <el-table-column  label="联系电话" prop="contact_number"></el-table-column>
                        <el-table-column  label="签约状态" prop="status_string"></el-table-column>
                        <el-table-column  label="余额" prop="balance_string" width="100px"></el-table-column>
                        <el-table-column  label="更新时间" prop="updated_at" width="180px"></el-table-column>
                        <!-- 对于不需要绑定的列则不需要绑定props,如果自定义表头的话也可以不需要绑定label  -->
                        <el-table-column width="220px"  fixed="right">
                            <!-- 绑定插槽slot="header"用来实现自定义表头,slot-scope="scope"返回数据： score:{row: '', $index: number} -->
                            <template slot="header" slot-scope="scope">
                                <span style="color: #409EFF">操作</span>
                            </template>
                            <!-- 默认插槽绑定列表内容插槽 scope: {$index: 当前下标, row: 当前数据对象} -->
                            <template slot-scope="scope">
                                <el-button size="mini" @click="openMenu(scope.$index, scope.row)"
                                           v-if="scope.row.status < 2" v-permission="'business.factor.list.recharge'">充值</el-button>
                                <el-button size="mini" @click="openEdit(scope.$index, scope.row)"
                                           v-if="scope.row.status < 2" v-permission="'business.factor.edit'">编辑</el-button>
                                <el-button size="mini" @click="handlerRescission(scope.$index, scope.row)"
                                           v-if="scope.row.status == 1" v-permission="'business.factor.list.unsign'">解约</el-button>
                                <el-button size="mini" @click="openSign(scope.$index, scope.row)"
                                           v-if="scope.row.status == 0 && scope.row.id != 1" v-permission="'business.factor.list.sign'">签约</el-button>
                                <el-button size="mini" @click="openShow(scope.$index, scope.row)"
                                           v-if="scope.row.status == 2" v-permission="'business.factor.edit'">查看</el-button>
                                <el-button size="mini" type="danger" v-if="scope.row.status == 2"
                                           @click="handleDelete(scope.$index, scope.row)" v-permission="'business.factor.delete'">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--  total：一共有多少条数据 page-size一个页面显示多少条数据 @current-change当点击分页数触发-->
                    <template v-if="list.length > 0">
                        <!-- :total="list.length" -->
                        <el-pagination background layout="total,prev, pager, next" :current-page="condition.page"  :total="condition.total" :page-size="condition.per_page" @current-change="currentChange"></el-pagination>
                    </template>
                    <recharge ref="recharge" :callback="initData" />
                    <signFactor ref="signFactor" :callback="initData" />
                    <add ref="add" :callback="initData" />
                    <edit ref="edit" @reload="initData" />
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<style>
    .el-table .danger-cell {
        color:#F56C6C;
    }
    .el-table .sign_cell div {
        white-space: pre-line;
    }
</style>
<script>
    import recharge from './listComponent/recharge'
    import signFactor from './listComponent/signFactor'
    import edit from './listComponent/edit'
    import add from './listComponent/add'
    import { parseTime } from '@/utils'
    import {getUser} from '@/utils/auth'
    import { deleteFactor, getFactorsList, modifyFactorStatus,getFactorDetail } from '@/service/user'
    import { getSite } from '@/service/site'
    import factorAutoComplete from '@/components/auto-complete/factor-auto-complete'
    export default {
        name: 'AgentList',
        components: {
            recharge,
            signFactor,
            add,
            edit,
            factorAutoComplete
        },
        data () {
            return {
                condition: {
                    id: '',
                    name: '',
                    status: '-1',
                    fee_status: '-1',
                    push_status:'-1',
                    contacts: '',
                    contact_number: '',
                    total : 0,
                    per_page : 10,
                    page : 1,
                },
                isShowCheckBox: true, // 是否显示多选框
                isLoading: false, // 是否显示loading加载
                list: [],
                checkList: [], // 当前选中下标列表
                sites : [],
                isShowMore: false
            }
        },
        mounted () {
            this.initData()
        },
        methods: {
            async querySearchAsync2 (queryString, callback) {
                let query = {
                    per_page : 10,
                    contacts : this.condition.contacts
                };
                let result = [];
                await getFactorsList(query).then((data) => {
                    result = data.data.filter(item => {
                        if (item.contacts.toLowerCase().indexOf(queryString.toLowerCase()) >= 0) return item
                    })
                });
                callback(result)
            },
            async querySearchAsync3 (queryString, callback) {
                let query = {
                    per_page : 10,
                    contact_number : this.condition.contact_number
                };
                let result = [];
                await getFactorsList(query).then((data) => {
                    result = data.data.filter(item => {
                        if (item.contact_number.toLowerCase().indexOf(queryString.toLowerCase()) >= 0) return item
                    })
                });
                callback(result)
            },
            /** 打开右侧悬浮层 */
            openMenu (index, row) {
                this.$refs.recharge && this.$refs.recharge.open(row)
            },
            openSign(index, row) {
                row['datas'] = this.sites;
                this.$refs.signFactor
                && ( Object.assign(this.$refs.signFactor.factorInfo, row))
                && ( Object.assign(this.$refs.signFactor.data, this.sites))
                && this.$refs.signFactor.open()
            },
            async openEdit(index, row) {
                await getFactorDetail(row.id).then((data) => {
                    data.sites.forEach(el => {
                        el.signDate=[new Date(el.sign_start_date),new Date(el.sign_end_date)]
                    });
                  this.$refs.edit
                    && ( Object.assign(this.$refs.edit.factorInfo, data))
                    && ( this.$refs.edit.data = data.sites.concat(this.sites))
                    && ( this.$refs.edit.checkedSites = [].concat(data.sites))
                    && this.$refs.edit.open()
                })
               
            },
            openShow(index, row) {
                this.$refs.edit
                && ( Object.assign(this.$refs.edit.factorInfo, row))
                && ( this.$refs.edit.data = row.sites.concat(this.sites))
                && ( this.$refs.edit.checkedSites = [].concat(row.sites))
                && ( this.$refs.edit.isShow = 1)
                && this.$refs.edit.open()
            },
            handleAdd() {
                let sites = JSON.parse(JSON.stringify(this.sites))
                this.$refs.add
                && ( Object.assign(this.$refs.add.data, sites))
                && this.$refs.add.open()
            },
            handleSearch() {
                this.condition.page = 1;
                this.initData()
            },
            resetSearch() {
                this.condition = {
                    id: '',
                    name: '',
                    status: '-1',
                    fee_status: '-1',
                    push_status:'-1',
                    contacts: '',
                    contact_number: '',
                    total : 0,
                    per_page : 10,
                    page : 1,
                };
                this.initData()
            },
            cellStatus ({row, column, rowIndex, columnIndex}) {
                if (column.property === 'fee_status_string' && row.fee_status == 1) {
                    return 'danger-cell'
                }
                if (column.property === 'balance' && row.balance < row.minimum_charge) {
                    return 'danger-cell'
                }
                if (column.property === 'status_string' && row.status_change_time) {
                    return 'sign_cell'
                }
            },
            /** 初始化数据请求 */
            async initData () {
                let query = this.condition;
                // 初始化之前设置当前页面的loading状态
                this.isLoading = true;
                // 模拟fetch请求数据....
                await getFactorsList(query).then((data) => {
                    this.condition.total= parseInt(data.total);
                    this.condition.per_page = parseInt(data.per_page);
                    let listData = data.data;
                    for (let i in listData) {
                        let row = listData[i];
                        if (row.sites.length > 0) {
                            let names = [];
                            for (let j in row.sites) {
                                if (j > 2) {
                                    names.push('...');
                                    break
                                } else {
                                    names.push(row.sites[j].name)
                                }
                            }
                            row.sites_string = names.join(',');
                            row.sites_placeholder = row.sites.map(v => v.name).join(',')
                        }  else {
                            row.sites_string = '--';
                            row.sites_placeholder = ''
                        }
                        switch (row.status) {
                            case 0:
                                row.status_string = '未签约';
                                break;
                            case 1:
                                row.status_string = '已签约';
                                break;
                            case 2:
                                row.status_string = '已解约';
                                break;
                            default:
                                row.status_string = '';
                                break;
                        }
                        switch (row.fee_status) {
                            case 0:
                                row.fee_status_string = '正常';
                                break;
                            case 1:
                                row.fee_status_string = '欠费';
                                break;
                            default:
                                row.fee_status_string = '';
                                break;
                        }
                        if (row.status_change_time && (row.status == 2 || row.status == 1)) {
                            row.status_string += "\n"+parseTime(new Date(row.status_change_time * 1000), '{y}-{m}-{d}')
                        }
                        if (row.updated_at) {
                            row.updated_at = parseTime(new Date(row.updated_at))
                        }
                        row.balance_string = (row.balance/100).toString() + '元'
                    }
                    this.list = listData
                });
                // 数据请求完毕取消当前页面的loading
                this.isLoading = false;
                let sites = {
                    'per_page' : 9999,
                    'factor_id' : 1
                };
                getSite(sites).then((data) => {
                    this.sites = [];
                    for(let i in data.data) {
                        this.sites.push({
                            id: data.data[i].id,
                            name: data.data[i].name,
                        });
                    }
                })
            },
            handleDelete (index, row) {
                this.$confirm('此操作将从列表汇总删除该条记录，不可恢复是否确定删除？', '提示').then(_ => {
                    deleteFactor(row.id).then((data) => {
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 3 * 1000
                        });
                        // 删除指定下标开始一条数据
                        this.list.splice(index, 1)
                    }).catch(err => {
                        this.$message({
                            message: err.message || '删除失败',
                            type: 'error',
                            duration: 3 * 1000
                        })
                    })
                }).catch(_ => {

                })
            },
            handlerRescission (index, row) {
                this.$confirm('此操作将会禁用该代理商关联的权限站点所有用户操作权限，是否确认解约？', '提示').then(_ => {
                    let query = {
                        "status": 2,
                    };
                    
                    modifyFactorStatus(row.id, query).then((data) => {
                        this.$message({
                            message: '解约成功',
                            type: 'success',
                            duration: 3 * 1000
                        });
                        // 删除指定下标开始一条数据
                        this.initData()
                    }).catch(err => {
                        this.$message({
                            message: err.message || '解约失败',
                            type: 'error',
                            duration: 3 * 1000
                        })
                    })
                }).catch(_ => {

                })
            },
            currentChange (index) {
                this.condition.page = index;
                this.initData()
            }
        }
    }
</script>
